"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeUndefinedOnly = exports.removeUndefined = void 0;
const removeUndefined = (obj) => {
    return Object.fromEntries(Object.entries(obj).filter(([_, value]) => value !== undefined && value !== null));
};
exports.removeUndefined = removeUndefined;
// Alternative version that only removes undefined (if you want to keep null values)
const removeUndefinedOnly = (obj) => {
    return Object.fromEntries(Object.entries(obj).filter(([_, value]) => value !== undefined));
};
exports.removeUndefinedOnly = removeUndefinedOnly;
//# sourceMappingURL=object.js.map